import { useEffect, useState } from "react";
import { toast } from "sonner";
import { format } from "date-fns";
import { Truck } from "lucide-react";
import api from "@/lib/api";
import { DeleteButton } from "@/components/DeleteButton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function AdminShipping() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/shipping/appointments").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  async function del(id) {
    try { await api.delete(`/shipping/appointments/${id}`); setItems((l) => l.filter((x) => x.id !== id)); toast.success("Appointment deleted."); }
    catch { toast.error("Failed to delete."); }
  }

  return (
    <div>
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary"><Truck className="h-6 w-6" /></div>
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">UPS Drop-Off Appointments</h1>
          <p className="text-sm text-muted-foreground">Package drop-offs reserved by customers.</p>
        </div>
      </div>

      <div className="mt-6 overflow-hidden rounded-xl border border-border/60 bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Reserved</TableHead><TableHead>Customer</TableHead><TableHead>Contact</TableHead>
              <TableHead className="text-right">Packages</TableHead><TableHead>Date</TableHead><TableHead>Time</TableHead><TableHead>Notes</TableHead><TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 ? (
              <TableRow><TableCell colSpan={8} className="py-10 text-center text-muted-foreground">No drop-off appointments yet.</TableCell></TableRow>
            ) : items.map((a) => (
              <TableRow key={a.id} data-testid={`ship-row-${a.id}`}>
                <TableCell className="whitespace-nowrap text-sm">{format(new Date(a.created_at), "MMM d, h:mm a")}</TableCell>
                <TableCell className="font-medium">{a.name}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{a.phone}<br />{a.email}</TableCell>
                <TableCell className="text-right"><Badge variant="outline">{a.package_count}</Badge></TableCell>
                <TableCell className="whitespace-nowrap">{a.preferred_date}</TableCell>
                <TableCell className="whitespace-nowrap">{a.preferred_time}</TableCell>
                <TableCell className="max-w-[16rem] truncate text-sm text-muted-foreground">{a.notes || "—"}</TableCell>
                <TableCell className="text-right"><DeleteButton onConfirm={() => del(a.id)} label="this appointment" testId={`ship-delete-${a.id}`} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
